module.exports = __webpack_public_path__ + "static/media/Scooter.b283b99a.svg";